import React, { useEffect, useState, useRef } from "react";
import EmployeeCard from "molecules/EmployeeCard";
import {
	Row,
	Col,
	Button,
	Spin,
	Modal,
	Tabs,
	message,
	Empty,
	Dropdown,
	Pagination,
} from "antd";
import { connect, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { reduce } from "lodash";
import { CSVLink } from "react-csv";
import {
	getUserList,
	getUserRoleId,
	getAllDepartmentList,
	getDepartmentUserList,
	getSelectedDepartmentId,
	getClientid,
	getMenuList,
	getLocations,
	getlevelList,
	getUserInfo,
	getCanViewOrganizationCharts,
	getFilters,
} from "redux/selectors";
import { setUserList } from "redux/actions";
import styled from "@emotion/styled";
import {
	CALL_API,
	FETCH_FULL_USER_LIST,
	FETCH_USERS_PAGE,
	FETCH_FILTER_LIST,
	FETCH_EXPORT_USER_LIST,
} from "common/API";
import { map } from "lodash";
import AddEmployee from "organisms/AddEmployee";
import Confirm from "../../src/assets/Confirm.svg";
import { encrypt, STATUS_CODE, MAIN_CLIENT_ID } from "common/Constants";
import { bindActionCreators } from "redux";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import moment from "moment";
import Organization from "molecules/Organization";
import { ReactComponent as IconLink } from "assets/Component 275 – 1.svg";
import useEmployeeFilter from "hooks/useEmployeeFilter";
import EmployeePerformance from "molecules/EmployeePerformance";

const StyledCol = styled(Col)`
  padding: 10px;
  .ant-card {
	border-radius: 10px !important;
  }
`;
const StyledTitle = styled.div`
  padding-left: 10px;
  padding-bottom: 10px;
  .ant-row {
	display: flex;
	flex-direction: column;
  }
  .ant-tabs-ink-bar {
	background-color: #000;
  }
  #rc-tabs-1-tab-1:hover,
  #rc-tabs-1-tab-2:hover {
	color: #000;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
	color: #000 !important;
  }
  .ant-tabs-tab {
	color: #b2beb5;
  }
`;

const HeaderRow = styled.div`
  margin-top: 6px;
  display: flex;
  justify-content: start;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 8px;

  .copy-icon {
	cursor: pointer;
  }
`;

const StyledContainerRow = styled(Row)`
  padding-top: 20px;
  .loader_container {
	width: 100%;
	text-align: center;
  }
  .noEmployee {
	width: 100%;
	text-align: center;
	color: grey;
	margin-top: 10%;
  }
`;

const StyleddeactivateModal = styled(Modal)`
  .ant-modal-header {
	border-bottom: none;
	padding: 35px 0px 20px 0px;
  }
  .ant-modal-content {
	box-shadow: 0px 0px 8px #00000029;
	border-radius: 5px;
  }
  .ant-modal-title {
	text-align: center;
	font-size: 16px;
  }
  .ant-modal-body {
	padding: 0px 0px 35px 0px;
  }
  .ant-modal-close-x {
	display: none;
  }
  .page-title-head {
	justify-content: center;
  }
  .ant-modal-footer {
	display: none;
  }
`;

const StyledModal = styled(Modal)`
  .ant-modal-header {
	border-bottom: none;
  }
  .ant-modal-content {
	box-shadow: 0px 0px 8px #00000029;
	border-radius: 5px;
  }
  .ant-modal-body {
	padding: 24px 0px 30px 0px;
  }
  .modal-body {
	justify-content: center;
	margin-top: 10px;
  }
  .ant-modal-close-x {
	color: #151515;
  }
  .modal-body-content {
	justify-content: center;
	font-size: 16px;
	color: #151515;
  }
  .ant-modal-footer {
	display: none;
  }
`;

const StyledButton = styled(Button)`
  width: 125px;
  color: white;
  background-color: #b7b7b7;
  border-radius: 5px;
  margin-left: 5%;
`;

// Module-level (not component-scoped) so they're safe to call from a lazy
// useState/useRef initializer on first render, before any in-component
// consts have been declared yet.
const EMPLOYEE_FILTER_FIELDS = [
	"employee",
	"supervisor",
	"competencyrole",
	"managingoffice",
	"leveldepartmentname",
	"competencyQC",
	"serviceline",
	"team",
	"grade",
];

const hasActiveFilters = (filters) =>
	Object.values(filters || {}).some(
		(values) => Array.isArray(values) && values.length > 0
	);

// Redux-persisted filter selections (see useEmployeeFilter.js's
// handleFormChange -> setFilter) come back as a sparse object; this fills in
// every field so downstream code can always treat it as a full filter set.
const normalizeEmployeeFilters = (filters) =>
	EMPLOYEE_FILTER_FIELDS.reduce((acc, field) => {
		acc[field] = filters?.[field] || [];
		return acc;
	}, {});

// useEmployeeFilter's form field names match the People card fields
// (employee/People, supervisor, etc.) — /filterlist expects `userid` for the
// People picker, everything else is a 1:1 name match.
const mapFiltersForFilterlistApi = (filters) => ({
	userid: filters.employee,
	supervisor: filters.supervisor,
	competencyrole: filters.competencyrole,
	managingoffice: filters.managingoffice,
	leveldepartmentname: filters.leveldepartmentname,
	competencyQC: filters.competencyQC,
	serviceline: filters.serviceline,
	team: filters.team,
	grade: filters.grade,
});

function Employee({
	ClientId,
	updateUserList,
	menuList,
	userRoleId,
	departmentList,
	userList,
	locationList,
	levelList,
	canViewOrganizationCharts,
}) {
	const EmployeeList = userList;
	const userClientId = useSelector(getClientid);
	const [encryptedClientId, setEncryptedClientId] = useState("");

	useEffect(() => {
		const encryptId = async () => {
			if (userClientId) {
				const result = await encrypt(String(userClientId));
				setEncryptedClientId(result);
			}
		};
		encryptId();
	}, [userClientId]);

	const [displayAddEmployeeModal, toggleAddEmployeeModal] = useState(false);
	const [selectedDepartment, setSelectedDepartment] = useState("");
	const [displayEmployeeLoader, setdisplayEmployeeLoader] = useState(false);
	const [deactivateEmployee, toggledeactivateEmployee] = useState(false);
	const [confirmdeactivateEmployee, toggleconfirmdeactivateEmployee] =
		useState(false);
	const [empId, setEmpId] = useState(0);
	const [employeeCSVlist, setEmployeeCSVlist] = useState([]);
	const [btnLoader, togglebtnLoader] = useState(false);
	const [csvExportLoading, setCsvExportLoading] = useState(false);
	const [employeeFilterList, setEmployeeFilterList] = useState([]);
	const [employeeType, setEmployeeType] = useState("1");
	const [statusCounts, setStatusCounts] = useState({
		activeUsersCount: 0,
		inactiveUsersCount: 0,
	});
	// True until loadStatusCounts resolves — kept separate from
	// displayEmployeeLoader (the card-list fetch) so the loader stays up until
	// BOTH the list and the "Total People" count have arrived, instead of
	// revealing the list first and having the count pop in a moment later.
	const [statusCountsLoading, setStatusCountsLoading] = useState(true);
	// Authoritative per-tab total from master-data (activeUsersCount for
	// Employee, inactiveUsersCount for Ex Employee) — drives both the "Total
	// People" label and the numbered Pagination below, instead of the length
	// of whatever page of get-users results happens to be loaded.
	const totalPeopleCount =
		employeeType === "0"
			? statusCounts.inactiveUsersCount
			: statusCounts.activeUsersCount;
	const containerRef = useRef(null);
	const csvLinkEl = useRef();
	// Cursor-based People pagination: page 1 has no cursor, and each
	// subsequent page's cursor is the previous get-users call's
	// LastEvaluatedKey. Cached per page so revisiting an already-fetched page
	// (e.g. "Previous") doesn't re-call the API; only reaching a page for the
	// first time does. Reset whenever the tab/status changes.
	const pageItemsCacheRef = useRef({});
	const pageCursorRef = useRef({});

	// FIX: always holds the latest employeeType so callbacks handed to
	// useEmployeeFilter (which may capture a stale closure) never load the
	// wrong tab's data.
	const employeeTypeRef = useRef("1");
	employeeTypeRef.current = employeeType;

	// FIX: monotonically increasing id for list loads. When a filter changes
	// quickly (or the filter hook fires onFilterChange more than once), older
	// in-flight responses are discarded so they can't overwrite newer results
	// or leave the loader in the wrong state.
	const loadRequestIdRef = useRef(0);

	// Current People-page filter bar selections (Country, Competency/QC,
	// Serviceline, Sub Serviceline, Department, Grade, Competency Role,
	// Office Supervisor, People). Seeded from Redux's persisted filter state
	// (the same store useEmployeeFilter.js's handleFormChange writes to) so
	// that navigating away to view a profile and back re-applies whatever
	// filter was active instead of silently falling back to the unfiltered
	// get-users view. A ref (not state) so loadPeoplePage/loadFilteredPeopleList
	// always read the latest selection without needing it in a dependency list.
	const persistedFilters = useSelector(getFilters);
	const activeFiltersRef = useRef(
		normalizeEmployeeFilters(persistedFilters?.employee)
	);
	// Mirrors whether activeFiltersRef currently has any selection — kept as
	// state (unlike the ref above) so the render can react to it: hides the
	// numbered Pagination and switches "Total People" to the filtered count
	// while a filter is applied. Seeded the same way as the ref above.
	const [filtersActive, setFiltersActive] = useState(() =>
		hasActiveFilters(persistedFilters?.employee)
	);

	const [managingOfficeData, setManagingOfficeData] = useState([]);
	const [competencyQCData, setCompetencyQCfetchData] = useState([]);
	const [servicelineData, setServicelinefetchData] = useState([]);
	const [subservicelineData, setsubservicelineData] = useState([]);
	const [departmentLevelData, setDepartmentLevelData] = useState([]);
	const headerstyle = { fontSize: "20px", fontWeight: "bold" };

	const items1 = [
		{
			key: 1,
			label: "Employee",
			children: <></>,
			id: "employee",
		},
		{
			key: 2,
			label: "Ex Employee",
			children: <></>,
			id: "exemployee",
		},
		{
			key: 3,
			label: "Office Org Chart",
			children: (
				<>
					<br />
					<Organization type="office" />
				</>
			),
			id: "officechart",
		},
		...(ClientId === MAIN_CLIENT_ID
			? [
				{
					key: 4,
					label: "Regional Org Chart",
					children: (
						<>
							<br />
							<Organization type="regional" />
						</>
					),
					id: "regionalchart",
				},
			]
			: []),
		{
			key: 5,
			label: "Employee Performance",
			children: (
				<>
					<br />
					<EmployeePerformance />
				</>
			),
			id: "employeeperformance",
		},
	];

	const CSVHeaders = [
		{ label: "Salutation", key: "Salutation" },
		{ label: "Initial", key: "Initial" },
		{ label: "User Id", key: "User Id" },
		{ label: "Name", key: "Name" },
		{ label: "Employee Id", key: "Employee Id" },
		{ label: "Date of Birth", key: "Date of Birth" },
		{ label: "Gender", key: "Gender" },
		{ label: "Age", key: "Age" },
		{ label: "Marital Status", key: "Marital Status" },
		{ label: "Greetings", key: "Greetings" },
		{ label: "Nationality", key: "Nationality" },
		{ label: "No Of Dependent", key: "No Of Dependent" },
		{ label: "UAN", key: "UAN" },
		{ label: "PAN", key: "PAN" },
		{ label: "Address", key: "Address" },
		{ label: "Phone No", key: "Phone No" },
		{ label: "Country", key: "Country" },
		{ label: "Competency/ QC", key: "Competency/ QC" },
		{ label: "Service Line", key: "Service Line" },
		{ label: "Sub Serviceline", key: "Sub Serviceline" },
		{ label: "Competency Role", key: "Competency Role" },
		{ label: "Location", key: "Location" },
		{ label: "Contracting Company", key: "Contracting Company" },
		{ label: "Primary Industry", key: "Primary Industry" },
		{ label: "Secondary Industry", key: "Secondary Industry" },
		{ label: "Sector", key: "Sector" },
		{ label: "Expertise", key: "Expertise" },
		{ label: "Industry Role", key: "Industry Role" },
		{ label: "Designation", key: "Designation" },
		{ label: "Grade", key: "Grade" },
		{ label: "Target Chargeability %", key: "Target Chargeability %" },
		{ label: "Charge Out Rate", key: "Charge Out Rate" },
		{ label: "Last Promotional Level", key: "Last Promotional Level" },
		{ label: "Last Promotional Date", key: "Last Promotional Date" },
		{ label: "Job Title", key: "Job Title" },
		{ label: "Professional Since", key: "Professional Since" },
		{ label: "Hired Date", key: "Hired Date" },
		{ label: "Relevant", key: "Relevant" },
		{ label: "Employee Sponser", key: "Employee Sponser" },
		{ label: "Job Description", key: "Job Description" },
		{ label: "Emergency Contact Name", key: "Emergency Contact Name" },
		{ label: "Emergency Contact Number", key: "Emergency Contact Number" },
		{ label: "Regional Supervisor", key: "Regional Supervisor" },
		{ label: "Office Supervisor", key: "Office Supervisor" },
		{ label: "Terminated Date", key: "Terminated Date" },
		{ label: "Terminated Reason", key: "Terminated Reason" },
	];

	const prepareCSV = async () => {
		setCsvExportLoading(true);
		const exportResult = await FETCH_EXPORT_USER_LIST(ClientId, employeeType);
		const exportList = exportResult?.userList || [];
		if (exportList.length > 0) {
			setEmployeeCSVlist(
				reduce(
					exportList,
					function (result, list) {
						const filterLevelLocationName = locationList?.find(
							(item) => item.location_id === list?.levellocationid
						);
						result.push({
							Salutation: list?.salutation || "",
							Initial: list?.initial || "",
							"User Id": list?.userid || "",
							Name: list?.fullname || "",
							"Employee Id": list?.employeeid || "",

							"Date of Birth":
								list?.dateofbirth && moment(list.dateofbirth).isValid()
									? moment.utc(list?.dateofbirth).format("DD/MM/YYYY")
									: "-",
							Gender: list?.gender || "",
							Age: list?.age || "",
							"Marital Status": list?.maritalstatus || "",
							"No Of Dependent": list?.dependent || "",
							Greetings: list?.greetings || "",
							Nationality: list?.nationality || "",
							NSSF: list?.nssf || "",
							"National ID": list?.national_id || "",
							Address: list?.presentaddress || "",
							"Phone No": list?.phoneno || "",
							Country: list?.managingoffice || "",
							"Competency/ QC": list?.competencyQC || "",
							"Service Line": list?.serviceline || "",
							"Sub Serviceline": list?.subserviceline || "",
							Department: list?.leveldepartmentname || "",
							"Competency Role": list?.competencyrole || "",
							"Institute Name": list?.institutename || "",
							Location: filterLevelLocationName?.location_name || "",
							"Contracting Company": list?.companyname || "",
							"Primary Industry": list?.industry || "",
							"Secondary Industry": list?.secondaryindustry || "",
							Sector: list?.sector || "",
							Expertise: list?.expertise || "",
							"Industry Role": list?.industryrole || "",
							Designation: list?.designation || "",
							Grade: list?.grade || "",
							"Target Chargeability %": list?.targetchargeability || "",
							"Charge Out Rate": list?.chargeoutrate || "",
							"Last Promotion Date":
								list?.lastpromotionlevel == null ||
									list?.lastpromotionlevel == ""
									? ""
									: moment(list?.lastpromotionlevel).format("DD-MM-YYYY") || "",
							"Last Promotional Level": list?.lastpromotion || "",
							"Job Title": list?.jobtitle || "",
							"Professional Since":
								list?.professionalsince &&
									moment(list.professionalsince).isValid()
									? moment(list.professionalsince).format("DD/MM/YYYY")
									: "-",
							"Hired Date":
								list?.hireddate && moment(list.hireddate).isValid()
									? moment(list.hireddate).format("DD/MM/YYYY")
									: "-",
							Relevant: list?.relevant || "",
							"Employee Sponser": list?.employeesponser || "",
							"Job Description": list?.jobdescription || "",
							"Emergency Contact Name": list?.emergencycontactname || "",
							"Emergency Contact Number": list?.emergencycontactnumber || "",
							"Regional Supervisor": list?.regionalsupervisor || "",
							"Office Supervisor": list?.officesupervisor || "",
							"Personal Email ID": list?.personalemailid || "",
							"Physical Address": list?.physicaladdress || "",
							"Work Permit No": list?.workpermitno || "",
							"Work Permit Expiry Date": list?.workpermitexpirydate
								? moment(list.workpermitexpirydate).format("DD/MM/YYYY")
								: "",
							"KRA PIN": list?.krapin || "",
							"Postal Address": list?.postaladdress || "",
							"Next of Kin Relationship": list?.nextofkinrelationship || "",
							"Next of Kin Address": list?.nextofkinpostaladdress || "",
							"Medical Insurance": list?.medicalInsurance || "",
							Oversight: list?.oversight ? "Yes" : "No",
							Appraiser:
								list?.appraisalInformation
									?.map((a) => {
										const name =
											a?.appraiserName ||
											a?.appraisername ||
											a?.appraiser ||
											"";
										const role = a?.roletype ? ` (${a.roletype})` : "";
										return name + role;
									})
									?.filter(Boolean)
									.join(" | ") || "",
						});

						if (list?.statusid === "0") {
							result.push({
								"Terminated Date": list?.terminated_date
									? moment(list?.terminated_date).format("DD/MM/YYYY")
									: "",
								"Terminated Reason": list?.terminated_reason,
							});
						}

						return result;
					},
					[]
				)
			);
			setTimeout(() => {
				csvLinkEl.current.link.click();
			});
		} else {
			message.error(`No data available to download.`);
		}
		setCsvExportLoading(false);
	};

	const resetPeoplePagination = () => {
		pageItemsCacheRef.current = {};
		pageCursorRef.current = {};
	};

	// No filters applied: card view is paginated, sourced one page at a time
	// from get-users?clientid=&statusid= (common/API.js FETCH_USERS_PAGE).
	// Page 1 is fetched with no cursor, and reaching page N for the first
	// time calls the API once more using the LastEvaluatedKey returned by
	// page N-1. Already-seen pages are served from pageItemsCacheRef without
	// another call.
	const loadPeoplePage = async (statusId, targetPage) => {
		if (!ClientId) return;
		const requestId = ++loadRequestIdRef.current;
		const cache = pageItemsCacheRef.current;
		if (cache[targetPage]) {
			setEmployeeFilterList(cache[targetPage]);
			setCurrentPage(targetPage);
			setdisplayEmployeeLoader(false);
			return;
		}
		setdisplayEmployeeLoader(true);
		try {
			const cursors = pageCursorRef.current;
			let page = 0;
			while (cache[page + 1]) {
				page += 1;
			}
			while (page < targetPage) {
				const nextPage = page + 1;
				const cursor = nextPage === 1 ? null : cursors[nextPage];
				const result = await FETCH_USERS_PAGE(ClientId, statusId, cursor);
				// A newer load started while this one was in flight — drop this one.
				if (requestId !== loadRequestIdRef.current) return;
				if (result?.code !== STATUS_CODE.SUCCESS) {
					break;
				}
				cache[nextPage] = result?.response || [];
				cursors[nextPage + 1] = result?.LastEvaluatedKey || null;
				page = nextPage;
			}
			if (requestId !== loadRequestIdRef.current) return;
			setEmployeeFilterList(cache[targetPage] || []);
			setCurrentPage(targetPage);
		} catch (error) {
			console.error("[loadPeoplePage] failed:", error);
		} finally {
			// Only the latest request controls the loader.
			if (requestId === loadRequestIdRef.current) {
				setdisplayEmployeeLoader(false);
			}
		}
	};

	// Any filter applied: NOT paginated — every match is fetched in one call
	// (the filterlist endpoint walks all its DynamoDB pages server-side) and
	// listed out in full, so there's no "page" UI to drive here.
	const loadFilteredPeopleList = async (statusId, filters) => {
		if (!ClientId) return;
		const requestId = ++loadRequestIdRef.current;
		setdisplayEmployeeLoader(true);
		try {
			const result = await FETCH_FILTER_LIST(
				ClientId,
				statusId,
				mapFiltersForFilterlistApi(filters)
			);
			// A newer load started while this one was in flight — drop this one.
			if (requestId !== loadRequestIdRef.current) return;
			setEmployeeFilterList(result?.userList || []);
			setCurrentPage(1);
		} catch (error) {
			console.error("[loadFilteredPeopleList] failed:", error);
			if (requestId === loadRequestIdRef.current) {
				setEmployeeFilterList([]);
			}
		} finally {
			if (requestId === loadRequestIdRef.current) {
				setdisplayEmployeeLoader(false);
			}
		}
	};

	// Single entry point for (re)loading the card list, used on tab switch and
	// after any mutation (add/delete/edit) — picks the filtered vs paginated
	// path based on whatever's currently selected in the filter bar.
	const reloadPeopleList = () => {
		const filters = activeFiltersRef.current;
		// FIX: read the type from the ref, not the closure, so a stale callback
		// can't fetch the wrong tab.
		const statusId = employeeTypeRef.current;
		if (hasActiveFilters(filters)) {
			loadFilteredPeopleList(statusId, filters);
		} else {
			resetPeoplePagination();
			loadPeoplePage(statusId, 1);
		}
	};

	// Fired by useEmployeeFilter whenever any filter dropdown changes.
	const handleFilterChange = (values) => {
		const filters = normalizeEmployeeFilters(values);
		activeFiltersRef.current = filters;
		setFiltersActive(hasActiveFilters(filters));
		reloadPeopleList();
	};

	const { FilterJSX, getFilterList } = useEmployeeFilter({
		employeeFilterList,
		allEmployeeList: EmployeeList,
		containerRef,
		managingOfficeData,
		competencyQCData,
		departmentLevelData,
		subservicelineData,
		servicelineData,
		menuName: "employee",
		employeeType: employeeType,
		onFilterChange: handleFilterChange,
	});

	const loadStatusCounts = async () => {
		if (!ClientId) return;
		setStatusCountsLoading(true);
		try {
			const result = await CALL_API(`master-data/${ClientId}`, "post", {
				fetch_master_data: true,
			});
			if (result?.code === STATUS_CODE.SUCCESS) {
				setStatusCounts({
					activeUsersCount: result?.activeUsersCount || 0,
					inactiveUsersCount: result?.inactiveUsersCount || 0,
				});
			}
		} catch (error) {
			console.error("[loadStatusCounts] failed:", error);
		} finally {
			setStatusCountsLoading(false);
		}
	};

	useEffect(() => {
		reloadPeopleList();
	}, [ClientId, employeeType]);

	useEffect(() => {
		loadStatusCounts();
	}, [ClientId]);

	const fetchMasterData = async (fetch_master_data) => {
		const [{ code, levelList }, userListResponse] = await Promise.all([
			CALL_API(`master-data/${ClientId}`, "post", { fetch_master_data }),
			fetch_master_data
				? FETCH_FULL_USER_LIST(ClientId)
				: Promise.resolve({}),
		]);

		if (code === STATUS_CODE.SUCCESS) {
			if (fetch_master_data) {
				let level1_values = [];
				let level2_values = [];
				let level3_values = [];
				let level4_values = [];
				let level5_values = [];

				updateUserList(userListResponse?.userList);

				levelList.forEach((level) => {
					switch (level.levelName) {
						case "Level1":
							level.value.forEach((value) => {
								value.value.forEach((item) => {
									level1_values.push(item);
								});
							});
							break;
						case "Level2":
							level.value.forEach((value) => {
								value.value.forEach((item) => {
									level2_values.push(item);
								});
							});
							break;
						case "Level3":
							level.value.forEach((value) => {
								value.value.forEach((item) => {
									level3_values.push(item);
								});
							});
							break;
						case "Level4":
							level.value.forEach((value) => {
								value.value.forEach((item) => {
									level4_values.push(item);
								});
							});
							break;
						case "Level5":
							level.value.forEach((value) => {
								value.value.forEach((item) => {
									level5_values.push(item);
								});
							});
							break;
						default:
							break;
					}
				});

				setManagingOfficeData(Array.from(level1_values));
				setCompetencyQCfetchData(Array.from(level2_values));
				setServicelinefetchData(Array.from(level3_values));
				setsubservicelineData(Array.from(level4_values));
				setDepartmentLevelData(Array.from(level5_values));
			}
		}
	};

	const refreshPeopleData = async (fetch_master_data) => {
		await fetchMasterData(fetch_master_data);
		reloadPeopleList();
		await loadStatusCounts();
	};

	const deletedEmployee = (EmpId) => {
		toggledeactivateEmployee(true);
		setEmpId(EmpId);
	};
	const deleteEmployee = async (employee_id) => {
		togglebtnLoader(true);
		await CALL_API(`add-users/${ClientId}`, "delete", {
			user_id: employee_id,
			status_id: "0",
			status_name: "inactive",
		});
		togglebtnLoader(false);
		toggledeactivateEmployee(false);
		toggleconfirmdeactivateEmployee(true);
		fetchMasterData();
		reloadPeopleList();
		loadStatusCounts();
	};

	const [activeTabKey, setActiveTabKey] = useState(1);

	const handleTabSelect = (key) => {
		if (key === 2) {
			setEmployeeType("0");
		} else {
			setEmployeeType("1");
		}
		setActiveTabKey(key);
	};

	const Menulist =
		menuList[userRoleId] || Object?.values(menuList)[0] || menuList;

	const filteredItems = items1.filter((item) => {
		if (
			["officechart", "regionalchart"].includes(item.id) &&
			!canViewOrganizationCharts
		) {
			return false;
		}

		const permissionObject = Menulist.find(
			(permission) => permission.key === item.id
		);
		return permissionObject ? permissionObject.permission.view : false;
	});

	const filtermenulist =
		Menulist &&
		Menulist?.filter(
			(data) =>
				data.key !== "managerdashboard" &&
				data.key !== "hrdashboard" &&
				data.key !== "teamcalendar" &&
				data.key !== "allcalendar"
		);

	useEffect(() => {
		if (levelList?.length > 0) {
			let level1_values = new Set();
			let level2_values = new Set();
			let level3_values = new Set();
			let level4_values = new Set();
			let level5_values = new Set();

			levelList.forEach((level) => {
				switch (level.levelName) {
					case "Level1":
						level.value.forEach((value) => {
							value.value.forEach((item) => {
								level1_values.add(item);
							});
						});
						break;
					case "Level2":
						level.value.forEach((value) => {
							value.value.forEach((item) => {
								level2_values.add(item);
							});
						});
						break;
					case "Level3":
						level.value.forEach((value) => {
							value.value.forEach((item) => {
								level3_values.add(item);
							});
						});
						break;
					case "Level4":
						level.value.forEach((value) => {
							value.value.forEach((item) => {
								level4_values.add(item);
							});
						});
						break;
					case "Level5":
						level.value.forEach((value) => {
							value.value.forEach((item) => {
								level5_values.add(item);
							});
						});
						break;
					default:
						break;
				}
			});

			setManagingOfficeData(Array.from(level1_values));
			setCompetencyQCfetchData(Array.from(level2_values));
			setServicelinefetchData(Array.from(level3_values));
			setsubservicelineData(Array.from(level4_values));
			setDepartmentLevelData(Array.from(level5_values));
		}
	}, [levelList]);

	const defaultPath =
		filtermenulist?.length > 0 ? filtermenulist[0]?.path : "/";

	const isEmployeeTab = activeTabKey === 1 || activeTabKey === 2;

	const items = [
		{
			key: "1",
			label: (
				<Link
					onClick={() => toggleAddEmployeeModal(true)}
					className="fw-semibold"
				>
					New Employee Form
				</Link>
			),
		},
		{
			key: "2",
			label: (
				<Link to="pending-employee" className="fw-semibold">
					Pending Employee
				</Link>
			),
		},
	];

	const linkToCopy = `https://www.uat.onboarding.bdo.insyts.co/?id=${encryptedClientId}`;
	const handleCopyClick = () => {
		navigator.clipboard
			.writeText(linkToCopy)
			.then(() => {
				message.success("Link copied");
			})
			.catch(() => {
				message.error("Failed to copy link");
			});
	};

	const [currentPage, setCurrentPage] = useState(1);
	// Matches get-users' server-side Limit (see handlers/tymeplusOwnerUsers/app.js
	// getUser), so each UI page maps to exactly one get-users call.
	const pageSize = 100;

	// Each page turn fetches (or reuses a cached) page via the cursor chain
	// in loadPeoplePage — no local slicing needed anymore.
	const handlePageChange = (page) => {
		loadPeoplePage(employeeTypeRef.current, page);
	};

	// FIX (main bug): when a filter is applied, the server (/filterlist) has
	// already returned exactly the matching users, so render them directly.
	// Previously the list was passed through getFilterList() from
	// useEmployeeFilter, which re-filters client-side and could drop every
	// row (e.g. field-name/casing mismatch on managingoffice), leaving
	// "Total People: 35" with an empty list.
	const getDisplayList = () => {
		if (filtersActive) {
			return employeeFilterList || [];
		}
		const list = getFilterList();
		return Array.isArray(list) ? list : employeeFilterList || [];
	};

	useEffect(() => {
		if (filteredItems) {
			setActiveTabKey(filteredItems[0]?.key);
		}
	}, []);

	const displayList = getDisplayList();

	return (
		<>
			{!displayAddEmployeeModal && (
				<>
					<StyledTitle className="page-title-head">
						<Row>
							<Tabs
								activeKey={activeTabKey}
								items={filteredItems}
								onChange={handleTabSelect}
								indicator={{
									size: (origin) => origin - 20,
									align: "center",
								}}
							/>
						</Row>
					</StyledTitle>

					{isEmployeeTab && FilterJSX}

					{isEmployeeTab && (
						<>
							<HeaderRow>
								<div className="people_font_style">
									Total People:{" "}
									{filtersActive
										? employeeFilterList?.length || 0
										: statusCountsLoading
											? 0
											: totalPeopleCount}
								</div>
								<CSVLink
									header={CSVHeaders}
									data={employeeCSVlist}
									filename={"Employee-list.csv"}
									asyncOnClick={true}
									ref={csvLinkEl}
								/>


								<Row
									justify="end"
									style={{ marginLeft: "auto", display: "flex", gap: "16px" }}
								>
									<ButtonOutlined
										className="m-0 ms-auto"
										onClick={prepareCSV}
										loading={csvExportLoading}
										disabled={csvExportLoading}
									>
										<span className="add-title">Export CSV File</span>
									</ButtonOutlined>

									{Menulist?.find(
										(item) => item?.key === "employee" && item?.permission.create
									) && (
											<div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
												<IconLink className="copy-icon" onClick={handleCopyClick} />
												<Dropdown menu={{ items }} placement="bottom" trigger={["hover"]}>
													<ButtonFilled className="apply-leave-sm m-0">
														Add People
													</ButtonFilled>
												</Dropdown>
											</div>
										)}
								</Row>
							</HeaderRow>
							<StyledContainerRow gutter={16}>
								{displayEmployeeLoader || statusCountsLoading ? (
									<div className="loader_container">
										<Spin spinning={displayEmployeeLoader || statusCountsLoading} />
									</div>
								) : (
									<>
										{displayList?.length > 0 ? (
											<>
												{map(displayList, (data, index) => (
													<StyledCol
														key={data.userid || index}
														xs={24}
														sm={12}
														md={12}
														lg={8}
														xl={6}
													>
														<Link
															to={`/profile-details/${data.userid}/?type=manage`}
														>
															<EmployeeCard
																id={data.userid}
																name={data.fullname}
																Department={data.department_name}
																clientid={data.clientid}
																employeeid={data.employeeid}
																data={data}
																getEmployeeList={refreshPeopleData}
																deletedEmployee={deletedEmployee}
																profile={data.profileurl}
																employeeType={employeeType}
																rolename={data.rolename}
															/>
														</Link>
													</StyledCol>
												))}
											</>
										) : (
											<>
												<p className="noEmployee">
													<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
												</p>
											</>
										)}
									</>
								)}
							</StyledContainerRow>
							{/* Numbered pagination, driven by master-data's active/inactive count.
							Hidden while a filter is applied — filtered results list every
							match at once instead (see loadFilteredPeopleList). */}
							{!filtersActive && !displayEmployeeLoader && !statusCountsLoading && totalPeopleCount > pageSize && (
								<Pagination
									current={totalPeopleCount > pageSize ? currentPage : 1}
									total={totalPeopleCount}
									pageSize={pageSize}
									onChange={handlePageChange}
									showSizeChanger={false}
									style={{ marginTop: "20px", textAlign: "center" }}
								/>
							)}
						</>
					)}
				</>
			)}
			{displayAddEmployeeModal && (
				<AddEmployee
					isModalVisible={displayAddEmployeeModal}
					closeModal={() => toggleAddEmployeeModal(false)}
					getEmployeeList={refreshPeopleData}
					setSelectedDepartment={setSelectedDepartment}
					EmployeeList={EmployeeList}
				/>
			)}
			<StyleddeactivateModal
				title="Are you sure you want to terminate this Employee?"
				visible={deactivateEmployee}
				width={500}
				onCancel={() => toggledeactivateEmployee(false)}
				footer={[]}
				centered
			>
				<Row className="page-title-head" gutter={16}>
					<Col>
						<StyledButton
							type="primary"
							htmlType="submit"
							onClick={() => toggledeactivateEmployee(false)}
						>
							No
						</StyledButton>
					</Col>
					<Col>
						<StyledButton
							loading={btnLoader}
							type="primary"
							htmlType="submit"
							onClick={() => deleteEmployee(empId)}
						>
							{btnLoader ? "Yes" : "Yes"}
						</StyledButton>
					</Col>
				</Row>
			</StyleddeactivateModal>
			<StyledModal
				visible={confirmdeactivateEmployee}
				width={500}
				onCancel={() => toggleconfirmdeactivateEmployee(false)}
				footer={[]}
				centered
			>
				<Row className="modal-body">
					<Col>
						<img src={Confirm} alt="confirm" height={45} width={45} />
					</Col>
				</Row>
				<Row className="modal-body-content">
					<Col>
						<p>This Employee has been terminated</p>
					</Col>
				</Row>
			</StyledModal>
		</>
	);
}
const mapStateToProps = (state) => ({
	userList: getUserList(state),
	userRoleId: getUserRoleId(state),
	allDepartmentList: getAllDepartmentList(state),
	departmentUserList: getDepartmentUserList(state),
	selectedDepartmentId: getSelectedDepartmentId(state),
	ClientId: getClientid(state),
	menuList: getMenuList(state),
	userInfo: getUserInfo(state),
	departmentList: getAllDepartmentList(state),
	locationList: getLocations(state),
	levelList: getlevelList(state),
	canViewOrganizationCharts: getCanViewOrganizationCharts(state),
});
const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			updateUserList: setUserList,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps, null)(Employee);